module.exports = __webpack_public_path__ + "static/img/zt1-pic4.52ef3f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt1-pic4.jpg
// module id = kpfD
// module chunks = 171